import React from 'react';
export var SubscriptionsContext = /*#__PURE__*/React.createContext({
  subscriptionOptions: []
});
export var SubscriptionsContextProvider = SubscriptionsContext.Provider;
export var SubscriptionsContextConsumer = SubscriptionsContext.Consumer;